//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiChevronLeft } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import { error, success } from '@core/utils/toasted'
import themeConfig from '@themeConfig'
// eslint-disable-next-line import/no-cycle
import { resetPassword } from '@api'
import { useRouter } from '@core/utils'

export default {
  setup() {
    const { router } = useRouter()
    const isPasswordVisible = ref(false)
    const username = ref('')
    const form = ref(null)

    const sendEmail = async () => {
      if (form.value.validate()) {
        const response = await resetPassword(username.value)
        if (response.ok) {
          success(response.message)
          router.push({ name: 'auth-login' })
        } else {
          error(response.message.text)
        }
      }
    }

    return {
      isPasswordVisible,
      username,
      form,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      sendEmail,

      // Validation
      validators: {
        required,
      },

      icons: {
        mdiChevronLeft,
      },
    }
  },
}
